import React from 'react';

interface SkeletonBlockProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

function toCssSize(value?: number | string): string | undefined {
  if (typeof value === 'number') return `${value}px`;
  return value;
}

export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  width,
  height,
  radius,
  className = '',
  style,
}) => {
  return (
    <div
      className={`aa-skeleton-block ${className}`}
      style={{
        width: toCssSize(width),
        height: toCssSize(height),
        borderRadius: toCssSize(radius),
        ...style,
      }}
      aria-hidden="true"
    />
  );
};
